// extracted by mini-css-extract-plugin
export default {"toggle-button":"toggle-button_toggle-button__7wOoH","button-icon":"toggle-button_button-icon__pOFSh","open":"toggle-button_open__Bp0OQ"};